import React from 'react';
import { useTranslation } from 'react-i18next';
import { GOOGLE_MAPS_URL } from '../../constants';
import './Testimonials.css';

function Testimonials() {
  const { t } = useTranslation();

  return (
    <section className="py-5 py-lg-6 bg-white border-top" id="testimonials">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center">
            <h2 className="h3 fw-semibold text-navy mb-2">{t('testimonials.heading')}</h2>
            <p className="text-muted mb-4">{t('testimonials.subheading')}</p>
            <p className="text-muted mb-4">{t('testimonials.googleCta')}</p>
            <a
              className="btn btn-navy"
              href={GOOGLE_MAPS_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('testimonials.googleButton')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
